import { ButtonBase, DialogContent, Grid2, styled as muiStyled } from '@mui/material'
import PhoneInput from 'react-phone-input-2'
import styled from 'styled-components'
import { DAY_CALENDAR_EACH_SLOT_TWO_ROW_HEIGHT_PX } from '../../../consumer/constants'

export const AvailabilityPageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-family: Outfit;
`

export const PageHeadlineContainer = styled.div`
  margin-bottom: 32px;
  padding: 20px 0;
  box-shadow: 0 20px 20px -20px rgb(0 0 0/15%);
`

export const PageHeadline = styled.div`
  max-width: 1020px;
  margin: 0 auto;
  font-size: 22px;
  font-weight: 400;
  color: #000;
  padding: 0 20px;
`

export const PageHeadlineComponent = ({ heading }) => {
  return (
    <PageHeadlineContainer>
      <PageHeadline>{heading}</PageHeadline>
    </PageHeadlineContainer>
  )
}

export const ClinicManageBookingsContainer = styled.div`
  @media print {
    display: none;
  }
  width: calc(100% - 40px);
  max-width: 980px;
  border: 1px solid #cccccc;
  border-radius: 8px;
  margin: 0 auto 40px;
  box-shadow: 0 1px 5px rgb(0 74 116/15%);
  background: #fff;
`

export const ClinicTabButton = styled.button`
  background: ${(props) => (props?.selected ? '#bcbcbc' : '#FFF')};
  border: 1px solid #000;
  border-radius: 15px;
  padding: 4px 8px;
`

export const ClinicTabButtonsContainer = styled.div`
  display: flex;
  padding: 10px 20px;
  flex-wrap: wrap;
  gap: 20px;
  border-bottom: 1px solid #cccccc;
`

//////////////////

// day view calendar styles
// EventsDayViewCalendar : EDVC

export const EDVCParent = styled.div`
  padding: 0 8px 16px 8px;
  padding-top: 0;
  margin: 0;
  margin-top: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-x: hidden;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  @media print {
    display: none;
  }
  @media (min-width: 768px) {
    padding: 0 16px 20px 16px;
    padding-top: 0;
    gap: 14px;
  }
  @media (min-width: 1200px) {
    padding: 0 24px 20px 24px;
    padding-top: 0;
    gap: 16px;
  }
`

export const EDVCEventsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-top: 0;
  width: 100%;
  flex-wrap: wrap;
  .chip-label {
    display: none;
  }
  @media (min-width: 768px) {
    gap: 12px;
    .chip-label {
      display: block;
    }
  }
`

export const EDVCNavigatorLabel = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: block;
  }
`

export const EDVCDateContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: ${props => props.compact ? 'wrap' : 'nowrap'};
  justify-content: center;
  align-items: center;
  gap: ${props => props.compact ? '8px' : '12px'};
  flex: 1 1 auto;
  min-width: 0;
  @media (max-width: 768px) {
    gap: 4px;
    flex-wrap: nowrap;
    flex: 1 1 auto;
  }
`

export const DateNavButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 7px 12px;
  border: 1px solid rgba(67, 56, 202, 0.25);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.95);
  color: rgba(67, 56, 202, 0.85);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(67, 56, 202, 0.05);
  flex-shrink: 0;
  
  &:hover {
    background: linear-gradient(135deg, rgba(67, 56, 202, 0.1) 0%, rgba(99, 102, 241, 0.1) 100%);
    border-color: rgba(67, 56, 202, 0.4);
    color: rgba(67, 56, 202, 1);
    transform: translateY(-1px);
    box-shadow: 0 3px 6px rgba(67, 56, 202, 0.15);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(67, 56, 202, 0.1);
  }
  
  @media (max-width: 768px) {
    padding: 8px 10px;
    font-size: 12px;
    gap: 0;
    border-radius: 8px;
    min-width: 44px;
    min-height: 44px;
  }
  
  svg {
    font-size: 16px;
    transition: transform 0.2s ease;
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
  
  &:hover svg {
    transform: scale(1.1);
  }
  
  @media (max-width: 768px) {
    &:hover svg {
      transform: scale(1);
    }
  }
`

export const TodayButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 7px 14px;
  border: 1px solid rgba(67, 56, 202, 0.3);
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(67, 56, 202, 0.12) 0%, rgba(99, 102, 241, 0.12) 100%);
  color: rgba(67, 56, 202, 0.95);
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 2px 4px rgba(67, 56, 202, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  white-space: nowrap;
  flex-shrink: 0;
  
  &:hover {
    background: linear-gradient(135deg, rgba(67, 56, 202, 0.18) 0%, rgba(99, 102, 241, 0.18) 100%);
    border-color: rgba(67, 56, 202, 0.5);
    color: rgba(67, 56, 202, 1);
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(67, 56, 202, 0.2);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(67, 56, 202, 0.15);
  }
  
  @media (max-width: 768px) {
    padding: 8px 12px;
    font-size: 12px;
    gap: 0;
    border-radius: 8px;
    min-width: 44px;
    min-height: 44px;
  }
  
  svg {
    font-size: 16px;
    transition: transform 0.2s ease;
    @media (max-width: 768px) {
      font-size: 18px;
    }
  }
  
  &:hover svg {
    transform: scale(1.1);
  }
  
  @media (max-width: 768px) {
    &:hover svg {
      transform: scale(1);
    }
  }
`

export const FilterTag = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid ${props => props.selected ? 'rgba(67, 56, 202, 0.4)' : 'rgba(67, 56, 202, 0.15)'};
  border-radius: 16px;
  background: ${props => props.selected 
    ? 'linear-gradient(135deg, rgba(67, 56, 202, 0.12) 0%, rgba(99, 102, 241, 0.12) 100%)' 
    : 'rgba(255, 255, 255, 0.9)'};
  color: ${props => props.selected ? 'rgba(67, 56, 202, 0.95)' : 'rgba(67, 56, 202, 0.7)'};
  font-size: 12px;
  font-weight: ${props => props.selected ? '600' : '500'};
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  white-space: nowrap;
  
  &:hover {
    background: ${props => props.selected 
      ? 'linear-gradient(135deg, rgba(67, 56, 202, 0.18) 0%, rgba(99, 102, 241, 0.18) 100%)' 
      : 'rgba(67, 56, 202, 0.06)'};
    border-color: ${props => props.selected ? 'rgba(67, 56, 202, 0.5)' : 'rgba(67, 56, 202, 0.25)'};
    color: ${props => props.selected ? 'rgba(67, 56, 202, 1)' : 'rgba(67, 56, 202, 0.85)'};
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(67, 56, 202, 0.1);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    padding: 5px 10px;
    font-size: 11px;
    gap: 4px;
  }

  svg {
    font-size: 14px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  .chip-main {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .chip-count {
    font-size: 11px;
    opacity: 0.7;
    line-height: 1;
  }
  /* Stacked: icon + label on the first line, count tucked beneath — a more compact pill. */
  ${props =>
    props.$stacked
      ? `
    flex-direction: column;
    gap: 1px;
    padding-top: 4px;
    padding-bottom: 4px;
    line-height: 1.1;
    .chip-count { font-size: 10px; opacity: 0.8; font-weight: 600; }
  `
      : ''}
`

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid ${props => props.selected ? 'rgba(67, 56, 202, 0.5)' : 'rgba(67, 56, 202, 0.2)'};
  border-radius: 20px;
  background: ${props => props.selected 
    ? 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)' 
    : 'rgba(255, 255, 255, 0.95)'};
  color: ${props => props.selected ? 'rgba(67, 56, 202, 1)' : 'rgba(67, 56, 202, 0.75)'};
  font-size: 12px;
  font-weight: ${props => props.selected ? '600' : '500'};
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  white-space: nowrap;
  box-shadow: ${props => props.selected ? '0 2px 4px rgba(67, 56, 202, 0.15)' : 'none'};
  
  &:hover {
    background: ${props => props.selected 
      ? 'linear-gradient(135deg, rgba(67, 56, 202, 0.2) 0%, rgba(99, 102, 241, 0.2) 100%)' 
      : 'rgba(67, 56, 202, 0.08)'};
    border-color: ${props => props.selected ? 'rgba(67, 56, 202, 0.6)' : 'rgba(67, 56, 202, 0.3)'};
    color: ${props => props.selected ? 'rgba(67, 56, 202, 1)' : 'rgba(67, 56, 202, 0.9)'};
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(67, 56, 202, 0.12);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    padding: 5px 12px;
    font-size: 11px;
    gap: 4px;
  }

  svg {
    font-size: 14px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }

  .chip-main {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .chip-count {
    font-size: 11px;
    opacity: 0.7;
    line-height: 1;
  }
  /* Stacked: icon + label on the first line, count tucked beneath — a more compact pill. */
  ${props =>
    props.$stacked
      ? `
    flex-direction: column;
    gap: 1px;
    padding-top: 4px;
    padding-bottom: 4px;
    line-height: 1.1;
    .chip-count { font-size: 10px; opacity: 0.8; font-weight: 600; }
  `
      : ''}
`

export const EDVCContainer = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 20px 10px;
  background: linear-gradient(135deg, rgba(249, 250, 251, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%);
  border-radius: 12px;
  border: 1px solid rgba(67, 56, 202, 0.08);
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-x: hidden;
  /* Removed overflow-y: hidden - was blocking parent scroll */
  box-shadow: 0 1px 3px rgba(67, 56, 202, 0.04);
  transition: all 0.3s ease;
  box-sizing: border-box;
  
  @media (min-width: 768px) {
    padding: 20px 16px;
    border-radius: 14px;
  }
  @media (min-width: 1200px) {
    padding: 20px 24px;
    border-radius: 16px;
  }
  
  @media (max-width: 600px) {
    padding: 12px 8px;
    border-radius: 10px;
  }
`

export const EDVCCollapsedHeader = styled.div`
  width: 100%;
  padding: 14px 18px;
  background: linear-gradient(135deg, rgba(67, 56, 202, 0.04) 0%, rgba(99, 102, 241, 0.04) 100%);
  border: 1px solid rgba(67, 56, 202, 0.12);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 8px 0 12px 0;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 1px 3px rgba(67, 56, 202, 0.08);
  
  &:hover {
    background: linear-gradient(135deg, rgba(67, 56, 202, 0.06) 0%, rgba(99, 102, 241, 0.06) 100%);
    border-color: rgba(67, 56, 202, 0.2);
    box-shadow: 0 2px 6px rgba(67, 56, 202, 0.12);
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 3px rgba(67, 56, 202, 0.1);
  }
  
  .collapse-label {
    font-size: 13px;
    font-weight: 600;
    color: rgba(67, 56, 202, 0.75);
    display: flex;
    align-items: center;
    gap: 8px;
    letter-spacing: 0.3px;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }
  
  @media (max-width: 600px) {
    padding: 12px 14px;
    border-radius: 8px;
    margin: 6px 0 10px 0;
    
    .collapse-label {
      font-size: 12px;
    }
  }
  
  .collapse-icon {
    color: rgba(67, 56, 202, 0.5);
    transition: transform 0.2s ease;
    font-size: 18px;
  }
  
  /* Subtle animation for icon when expanded */
  &.expanded .collapse-icon {
    transform: rotate(180deg);
  }
`

export const TimeSectionHeader = styled.div`
  width: 100%;
  padding: 8px 12px;
  margin: 12px 0 8px 0;
  background: transparent;
  border-bottom: 1px solid rgba(67, 56, 202, 0.12);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  
  .section-title {
    font-size: 13px;
    font-weight: 600;
    color: rgba(67, 56, 202, 0.55);
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }
  
  .section-subtitle {
    font-size: 11px;
    font-weight: 400;
    color: rgba(67, 56, 202, 0.4);
    margin-top: 2px;
    letter-spacing: 0.3px;
  }
`

export const EDVCSlotItemContainer = styled.div`
  width: 100%;
  height: ${(props) => props?.heightOfEachSlot || `${DAY_CALENDAR_EACH_SLOT_TWO_ROW_HEIGHT_PX}px`};
  display: flex;
`

export const EDVCSlotItemTime = styled.div`
  width: 50px;
  min-width: 50px;
  flex-shrink: 0;
  position: relative;
  padding-left: 4px;
  background: linear-gradient(135deg, rgba(67, 56, 202, 0.02) 0%, rgba(99, 102, 241, 0.02) 100%);
  border-right: 1px solid rgba(67, 56, 202, 0.1);
  
  @media (max-width: 600px) {
    width: 45px;
    min-width: 45px;
    padding-left: 2px;
  }
`

export const EDVCSlotStartTime = styled.div`
  position: absolute;
  right: 4px;
  top: 0;
  transform: translateY(-50%);
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: visible;
  color: rgba(67, 56, 202, 0.7);
  font-weight: 600;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto Mono', monospace;
  letter-spacing: 0.2px;
  
  @media (max-width: 600px) {
    font-size: 10px;
    right: 3px;
  }
`

export const EDVCSlotItem = styled.div`
  flex: 1;
  min-width: 0;
  background: #ffffff;
  border-top: 1px solid rgba(67, 56, 202, 0.08);
  height: ${(props) => `${props?.heightOfEachSlot || DAY_CALENDAR_EACH_SLOT_TWO_ROW_HEIGHT_PX}px`};
  display: flex;
  align-items: center;
  overflow: hidden;
  color: rgba(67, 56, 202, 0.6);
  font-weight: 500;
  padding: 0 10px;
  transition: all 0.15s ease;
  cursor: pointer;
  position: relative;
  
  &:hover {
    background: linear-gradient(135deg, rgba(67, 56, 202, 0.03) 0%, rgba(99, 102, 241, 0.03) 100%);
    border-top-color: rgba(67, 56, 202, 0.15);
  }
  
  &:active {
    background: linear-gradient(135deg, rgba(67, 56, 202, 0.05) 0%, rgba(99, 102, 241, 0.05) 100%);
  }
  
  @media (max-width: 600px) {
    padding: 0 8px;
    border-top-width: 0.5px;
  }
  
  /* Subtle alternating row effect for better readability */
  &:nth-child(even) {
    background: rgba(249, 250, 251, 0.5);
    
    &:hover {
      background: linear-gradient(135deg, rgba(67, 56, 202, 0.04) 0%, rgba(99, 102, 241, 0.04) 100%);
    }
  }
`

const EDVC_STRIP_LEFT_PX = 60
const EDVC_STRIP_RIGHT_PX = 10
const EDVC_STRIP_GAP_PX = 4

export const EDVCSlotColoredItem = styled.div`
  position: absolute;
  top: ${(props) => `${20 + props?.fromTopInPx}px`};
  height: ${(props) => `${props?.heightInPx}px`};
  left: ${(props) => {
    const total = props?.overlapTotal
    const index = props?.overlapIndex
    if (total > 1 && typeof index === 'number') {
      const available = '100%'
      const gapTotal = (total - 1) * EDVC_STRIP_GAP_PX
      return `calc(${EDVC_STRIP_LEFT_PX}px + ${index} * (${available} - ${EDVC_STRIP_LEFT_PX}px - ${EDVC_STRIP_RIGHT_PX}px - ${gapTotal}px) / ${total} + ${index} * ${EDVC_STRIP_GAP_PX}px)`
    }
    return '60px'
  }};
  right: ${(props) => (props?.overlapTotal > 1 ? 'auto' : '10px')};
  width: ${(props) => {
    const total = props?.overlapTotal
    if (total > 1) {
      const gapTotal = (total - 1) * EDVC_STRIP_GAP_PX
      return `calc((100% - ${EDVC_STRIP_LEFT_PX}px - ${EDVC_STRIP_RIGHT_PX}px - ${gapTotal}px) / ${total})`
    }
    return 'auto'
  }};
  min-width: ${(props) => (props?.overlapTotal > 1 ? '60px' : 'auto')};
  max-width: ${(props) => (props?.overlapTotal > 1 ? 'none' : 'auto')};
  ${(props) => props?.overlapTotal > 1 && `margin-right: ${EDVC_STRIP_GAP_PX}px;`}
  background: #E8E9EA;
  ${(props) => props?.stripColor && `background: ${props?.stripColor}`};
  border: 2px solid rgba(67, 56, 202, 0.4);
  ${(props) => props?.stripBorderColor && `border: 2px solid ${props?.stripBorderColor}`};
  ${(props) => props?.emergencyEvent && props?.stripBorderColor && `border: 3px solid ${props?.stripBorderColor} !important;`};
  /* REQUIREMENT: Thick border for external (other clinic) bookings - distinct purple color */
  ${(props) => props?.isExternalClinic && `
    border: 3px solid #8B5CF6 !important;
    /* Slanted diagonal lines pattern for other clinic cards */
    background-image: repeating-linear-gradient(
      45deg,
      transparent,
      transparent 10px,
      rgba(139, 92, 246, 0.08) 10px,
      rgba(139, 92, 246, 0.08) 20px
    );
    background-color: ${props?.stripColor || '#F3F4F6'};
  `};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: ${(props) => props.stripTextColor || 'rgba(67, 56, 202, 0.9)'};
  font-weight: 600;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  cursor: pointer;
  padding: 0;
  border-radius: 10px;
  box-shadow: 
    0 2px 8px rgba(67, 56, 202, 0.12),
    0 1px 3px rgba(0, 0, 0, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  ${(props) => props?.emergencyEvent && props?.stripBorderColor && `
    box-shadow: 
      0 2px 8px rgba(239, 68, 68, 0.25),
      0 1px 3px rgba(239, 68, 68, 0.15),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
  `};
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    box-shadow: 
      0 6px 20px rgba(67, 56, 202, 0.18),
      0 3px 10px rgba(0, 0, 0, 0.12),
      inset 0 1px 0 rgba(255, 255, 255, 0.15);
    ${(props) => props?.emergencyEvent && props?.stripBorderColor && `
      box-shadow: 
        0 6px 20px rgba(239, 68, 68, 0.3),
        0 3px 10px rgba(239, 68, 68, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.15);
    `};
    ${(props) => props?.isExternalClinic && `
      box-shadow: 
        0 6px 20px rgba(139, 92, 246, 0.25),
        0 3px 10px rgba(139, 92, 246, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.15);
    `};
    transform: translateY(-2px);
    border-width: 2.5px;
    ${(props) => props?.emergencyEvent && props?.stripBorderColor && `border-width: 3.5px;`};
    ${(props) => props?.isExternalClinic && `border-width: 3.5px !important; border-color: #8B5CF6 !important;`};
    border-color: ${(props) => props?.stripBorderColor || 'rgba(67, 56, 202, 0.6)'};
  }
  
  &:active {
    transform: translateY(-1px);
    box-shadow: 
      0 3px 12px rgba(67, 56, 202, 0.15),
      0 1px 4px rgba(0, 0, 0, 0.1);
  }
  
  @media (max-width: 600px) {
    ${(props) => props?.overlapTotal <= 1 && 'left: 53px; right: 8px;'}
    border-radius: 8px;
    border-width: 1.5px;
    font-size: 11px;
  }
  @media (min-width: 768px) {
    ${(props) => props?.overlapTotal <= 1 && 'left: 66px; right: 16px;'}
    border-radius: 12px;
  }
  @media (min-width: 1200px) {
    ${(props) => props?.overlapTotal <= 1 && 'left: 74px; right: 24px;'}
    border-radius: 14px;
  }
  @media (max-width: 768px) {
    font-size: 11px;
  }
`

export const EDVCBookedSlotDetailsContainer = styled.div`
  width: 350px;
`

export const EDVCButton = styled.button`
  color: ${(props) => (props?.invert ? '#FFF' : '#864ef5')};
  background: ${(props) => (props?.invert ? '#864ef5' : '#FFF')};
  font-weight: 500;
  border: 1px solid #864ef5;
  border-radius: 15px;
  font-size: 14px;
  padding: 2px 8px;
  display: flex;
  margin-top: 3px;
  justify-content: center;
  align-items: center;
  &:disabled {
    color: #fff;
    background: #929292;
    border: 1px solid #929292;
  }
`

/*
 * Bottom padding stays 0 so the sticky action footer inside the booking dialog can sit flush
 * against the scrollport edge (the footer carries its own padding). The horizontal padding here
 * must stay in sync with the sticky footer's negative-margin bleed in NewBookingDialogComponent
 * (12px below 600px, 20px above).
 */
export const EDVCNewBookingContainer = styled(DialogContent)`
  min-width: 400px;
  min-height: 400px;
  padding: 12px 12px 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  @media (max-width: 768px) {
    min-width: 100%;
  }
  @media (min-width: 769px) and (max-width: 980px) {
    min-width: calc(100vw - 64px);
  }
  @media (min-width: 600px) {
    padding: 20px 20px 0;
  }
`

export const EDVCBookNewSlotInput = styled.input`
  color: rgba(67, 56, 202, 0.9);
  border: 1px solid rgba(67, 56, 202, 0.2);
  border-radius: 8px;
  padding: 5px 10px;
  width: 100%;
  transition: all 0.2s ease;
  &:focus {
    outline: none;
    border-color: rgba(67, 56, 202, 0.4);
    box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.1);
  }
  &:hover {
    border-color: rgba(67, 56, 202, 0.3);
  }
`

export const EDVCBookNewSlotSelect = styled.select`
  border: 1px solid rgba(67, 56, 202, 0.2);
  border-radius: 8px;
  padding: 5px 10px;
  width: 100%;
  color: rgba(67, 56, 202, 0.9);
  background-color: #ffffff;
  transition: all 0.2s ease;
  &:focus {
    outline: none;
    border-color: rgba(67, 56, 202, 0.4);
    box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.1);
  }
  &:hover {
    border-color: rgba(67, 56, 202, 0.3);
  }
`

export const EDVCPresentTimeLine = styled.div`
  position: absolute;
  top: ${(props) => `${20 + props?.fromTopInPx}px`};
  left: 50px;
  right: 0px;
  width: auto;
  background: linear-gradient(90deg, #ea4335 0%, #f87171 100%);
  height: 2.5px;
  z-index: 5;
  box-shadow: 
    0 0 6px rgba(234, 67, 53, 0.6),
    0 0 12px rgba(234, 67, 53, 0.3);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 2px;
  
  &:hover {
    height: 3.5px;
    box-shadow: 
      0 0 10px rgba(234, 67, 53, 0.8),
      0 0 20px rgba(234, 67, 53, 0.4);
    background: linear-gradient(90deg, #d32f2f 0%, #ef4444 100%);
    
    /* Highlight the tag when hovering over the line */
    & ~ .time-tag {
      transform: scale(1.1);
      box-shadow: 0 4px 12px rgba(234, 67, 53, 0.6);
      background: #d32f2f;
    }
    
    /* Also trigger parent hover state */
    & + .time-tag {
      transform: scale(1.1);
      box-shadow: 0 4px 12px rgba(234, 67, 53, 0.6);
      background: #d32f2f;
    }
  }
  
  /* When line is hovered, highlight sibling tag */
  &:hover ~ .time-tag {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(234, 67, 53, 0.6);
    background: #d32f2f;
    
    &::before {
      border-left-color: #d32f2f;
    }
  }
  
  @media (max-width: 600px) {
    height: 2px;
    left: 45px;
    
    &:hover {
      height: 3px;
    }
  }
`

export const EDVCPresentTimeLineDot = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 10px;
  width: 10px;
  background: linear-gradient(135deg, #ea4335 0%, #f87171 100%);
  border-radius: 50%;
  z-index: 6;
  box-shadow: 
    0 0 6px rgba(234, 67, 53, 0.7),
    0 0 12px rgba(234, 67, 53, 0.4),
    inset 0 1px 2px rgba(255, 255, 255, 0.2);
  border: 2px solid #ffffff;
  transition: all 0.3s ease;
  
  @media (max-width: 600px) {
    height: 8px;
    width: 8px;
    border-width: 1.5px;
  }
`

export const EDVCPresentTimeTag = styled.div`
  position: absolute;
  top: ${(props) => `${20 + props?.fromTopInPx - 10}px`};
  left: 0px;
  background: linear-gradient(135deg, #ea4335 0%, #f87171 100%);
  color: white;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto Mono', monospace;
  white-space: nowrap;
  z-index: 7;
  box-shadow: 
    0 3px 8px rgba(234, 67, 53, 0.5),
    0 0 0 1px rgba(255, 255, 255, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  min-width: 55px;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
`

export const EDVCSlotDurationFloater = styled.div`
  position: absolute;
  top: ${(props) => `${20 + props?.fromTopInPx - 18}px`};
  left: 0px;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, rgba(67, 56, 202, 0.95) 0%, rgba(79, 70, 229, 0.95) 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1002;
  box-shadow: 
    0 4px 12px rgba(67, 56, 202, 0.4),
    0 2px 6px rgba(0, 0, 0, 0.2),
    0 0 0 2px rgba(255, 255, 255, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    background: linear-gradient(135deg, rgba(67, 56, 202, 1) 0%, rgba(79, 70, 229, 1) 100%);
    transform: scale(1.15);
    box-shadow: 
      0 6px 16px rgba(67, 56, 202, 0.5),
      0 3px 8px rgba(0, 0, 0, 0.25),
      0 0 0 2px rgba(255, 255, 255, 0.2);
  }
  
  &:active {
    transform: scale(1.1);
  }
  
  @media (max-width: 600px) {
    width: 32px;
    height: 32px;
    left: 0px;
    top: ${(props) => `${12 + props?.fromTopInPx - 16}px`};
  }
  
  @media (min-width: 768px) {
    width: 40px;
    height: 40px;
  }
  
  svg {
    font-size: 20px;
    @media (max-width: 600px) {
      font-size: 18px;
    }
    @media (min-width: 768px) {
      font-size: 22px;
    }
  }
  opacity: 1;
  visibility: visible;
  line-height: 1.3;
  letter-spacing: 0.3px;
`

export const EDVCSlotDurationSlider = styled.div`
  position: absolute;
  top: ${(props) => `${20 + props?.fromTopInPx - (props?.height || 0) / 2}px`};
  left: 0px;
  width: 24px;
  height: ${(props) => `${props?.height || 200}px`};
  background: linear-gradient(180deg, rgba(67, 56, 202, 0.7) 0%, rgba(79, 70, 229, 0.7) 100%);
  border-radius: 12px;
  z-index: 1503 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  box-shadow: 
    0 8px 24px rgba(67, 56, 202, 0.6),
    0 4px 12px rgba(0, 0, 0, 0.35),
    inset 0 2px 0 rgba(255, 255, 255, 0.5),
    inset 0 -2px 0 rgba(0, 0, 0, 0.2);
  border: 2px solid rgba(67, 56, 202, 0.8);
  backdrop-filter: blur(16px);
  
  .slider-track {
    position: absolute;
    left: 50%;
    top: 12px;
    bottom: 12px;
    width: 3px;
    background: rgba(67, 56, 202, 0.3);
    border-radius: 2px;
    transform: translateX(-50%);
  }
  
  .slider-thumb {
    position: absolute;
    left: 50%;
    width: 24px;
    height: 24px;
    background: linear-gradient(135deg, rgba(67, 56, 202, 1) 0%, rgba(79, 70, 229, 1) 100%);
    border: 3px solid white;
    border-radius: 50%;
    transform: translateX(-50%);
    cursor: grab;
    box-shadow: 
      0 4px 12px rgba(67, 56, 202, 0.5),
      0 2px 6px rgba(0, 0, 0, 0.3),
      0 0 0 2px rgba(67, 56, 202, 0.2);
    transition: transform 0.1s ease, box-shadow 0.1s ease;
    z-index: 10;
    
    &:hover {
      transform: translateX(-50%) scale(1.15);
      box-shadow: 
        0 6px 16px rgba(67, 56, 202, 0.6),
        0 3px 8px rgba(0, 0, 0, 0.35),
        0 0 0 3px rgba(67, 56, 202, 0.3);
    }
    
    &:active {
      cursor: grabbing;
      transform: translateX(-50%) scale(1.2);
      box-shadow: 
        0 8px 20px rgba(67, 56, 202, 0.7),
        0 4px 10px rgba(0, 0, 0, 0.4),
        0 0 0 4px rgba(67, 56, 202, 0.4);
    }
  }
  
  .slider-label {
    position: absolute;
    right: 24px;
    font-size: 11px;
    font-weight: 700;
    color: rgba(67, 56, 202, 0.9);
    white-space: nowrap;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto Mono', monospace;
    background: rgba(255, 255, 255, 0.98);
    padding: 4px 8px;
    border-radius: 6px;
    box-shadow: 
      0 2px 8px rgba(67, 56, 202, 0.2),
      0 0 0 1px rgba(67, 56, 202, 0.15);
    border: 1px solid rgba(67, 56, 202, 0.2);
  }
  
  .slider-label-top {
    top: -4px;
  }
  
  .slider-label-bottom {
    bottom: -4px;
  }
  
  @media (max-width: 600px) {
    right: 6px;
    width: 14px;
    padding: 10px 0;
    
    .slider-thumb {
      width: 22px;
      height: 22px;
      border-width: 2px;
    }
    
    .slider-label {
      font-size: 10px;
      right: 20px;
      padding: 3px 6px;
    }
    
    .slider-track {
      top: 10px;
      bottom: 10px;
    }
  }
`

export const EDVCSlotDurationOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(8px);
  z-index: 1501;
  pointer-events: auto;
  transition: opacity 0.3s ease;
  
  .highlighted-slot {
    position: relative !important;
    z-index: 1502 !important;
    transition: height 0.1s ease-out !important;
    transform: none !important;
    box-shadow: 
      0 8px 32px rgba(67, 56, 202, 0.4),
      0 4px 16px rgba(0, 0, 0, 0.3),
      inset 0 0 0 2px rgba(67, 56, 202, 0.3) !important;
    opacity: 1 !important;
    pointer-events: auto !important;
    isolation: isolate;
  }
  
  .dimmed-content {
    opacity: 0.2;
    pointer-events: none;
    transition: opacity 0.3s ease;
  }
  
  /* Ensure the slider and close button are above overlay */
  [class*="EDVCSlotDurationSlider"] {
    z-index: 1503 !important;
  }
  
  [class*="EDVCSliderCloseButton"] {
    z-index: 1504 !important;
  }
`

export const EDVCSliderCloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(67, 56, 202, 0.95) 0%, rgba(79, 70, 229, 0.95) 100%);
  color: white;
  border: 2px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1504 !important;
  box-shadow: 
    0 4px 12px rgba(67, 56, 202, 0.4),
    0 2px 6px rgba(0, 0, 0, 0.2);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    background: linear-gradient(135deg, rgba(67, 56, 202, 1) 0%, rgba(79, 70, 229, 1) 100%);
    transform: scale(1.1);
    box-shadow: 
      0 6px 16px rgba(67, 56, 202, 0.5),
      0 3px 8px rgba(0, 0, 0, 0.25);
  }
  
  &:active {
    transform: scale(1.05);
  }
  
  svg {
    font-size: 18px;
  }
  
  @media (max-width: 600px) {
    width: 28px;
    height: 28px;
    top: 6px;
    right: 6px;
    
    svg {
      font-size: 16px;
    }
  }
`

// Add global styles for hover effect
export const TimeLineWrapperStyles = `
  .time-line-wrapper:hover .time-tag {
    transform: scale(1.1) !important;
    box-shadow: 0 4px 12px rgba(234, 67, 53, 0.6) !important;
    background: #d32f2f !important;
  }
  
  .time-line-wrapper:hover .time-tag::before {
    border-left-color: #d32f2f !important;
  }
`

export const EDVCExtraSlotItemForTime = styled(EDVCSlotItem)`
  background: linear-gradient(135deg, rgba(249, 250, 251, 0.8) 0%, rgba(255, 255, 255, 0.8) 100%);
  position: relative;
  border-radius: 8px;
  border-top: unset;
  border: 1px dashed rgba(67, 56, 202, 0.15);
  z-index: 999;
  overflow: visible;
  margin-left: 0;
  padding-left: 0;
  
  .time-line-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: visible;
    margin-left: 0;
    padding-left: 0;
    
    &:hover .time-tag {
      transform: scale(1.1) !important;
      box-shadow: 0 4px 12px rgba(234, 67, 53, 0.6) !important;
      background: #d32f2f !important;
      
      &::before {
        border-left-color: #d32f2f !important;
      }
    }
  }
  
  @media (max-width: 600px) {
    border-radius: 6px;
  }
`

export const EDVCSlotButton = styled.button`
  padding: 2px 8px;
  border-radius: 10px;
  height: fit-content;
  background: ${(props) => (props?.infoVariant ? '#3d84ff' : '#e6f3ff')};
  color: ${(props) => (props?.infoVariant ? '#fff' : '#523b55')};
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 900px) {
    ${(props) => props?.hideOnSmallWidth && `display: none;`};
  }
`

export const EDVCRectangleButton = styled.button`
  height: 38px;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
  border-radius: 4px;
  border: 1px solid #b3b3b3;
  background: ${(props) => props?.action && '#d6cbfe'};
  color: #4d4d50;
  &:disabled {
    background: transparent;
  }
`

export const EDVCCalendarNavigator = muiStyled('div')(
  ({ theme, useSticky = false, isOnLeft = false }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: ${useSticky ? 'sticky' : 'fixed'};
  padding: 8px 6px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.5);
  z-index: 2000;
  top: unset;
  bottom: 12px;
  left: 50%;
  right: auto;
  transform: translateX(-50%);
  
  /* On mobile, always use fixed positioning regardless of useSticky prop */
  @media (max-width: 767px) {
    position: fixed !important;
    bottom: 12px !important;
    left: 50% !important;
    right: auto !important;
    top: unset !important;
    transform: translateX(-50%) !important;
  }
  
  @media (min-width: 768px) {
    position: ${useSticky ? 'sticky' : 'fixed'};
    transform: unset;
    flex-direction: column;
    top: 50vh;
    left: auto;
    right: 8px;
    transform: translateY(-50%);
    bottom: auto;
    gap: 6px;
    padding: 6px 4px;
    border-radius: 14px;
  }
  
  @media (min-width: 1200px) {
    right: 12px;
  }
  
  @media (max-width: 600px) {
    bottom: 8px;
    padding: 6px 4px;
    gap: 6px;
    border-radius: 10px;
  }
`,
)

export const EDVCNavButton = muiStyled('button')(
  ({ theme, variant = 'default' }) => {
    const variantStyles = {
      first: {
        background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.9) 0%, rgba(99, 102, 241, 0.9) 100%)',
        color: '#ffffff',
        borderColor: 'rgba(67, 56, 202, 0.3)',
        hoverBackground: 'linear-gradient(135deg, rgba(67, 56, 202, 1) 0%, rgba(99, 102, 241, 1) 100%)',
        hoverShadow: '0 6px 20px rgba(67, 56, 202, 0.25)',
      },
      now: {
        background: 'linear-gradient(135deg, #ea4335 0%, #f87171 100%)',
        color: '#ffffff',
        borderColor: 'rgba(234, 67, 53, 0.3)',
        hoverBackground: 'linear-gradient(135deg, #d32f2f 0%, #ef4444 100%)',
        hoverShadow: '0 6px 20px rgba(234, 67, 53, 0.3)',
      },
      next: {
        background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.85) 0%, rgba(99, 102, 241, 0.85) 100%)',
        color: '#ffffff',
        borderColor: 'rgba(67, 56, 202, 0.3)',
        hoverBackground: 'linear-gradient(135deg, rgba(67, 56, 202, 1) 0%, rgba(99, 102, 241, 1) 100%)',
        hoverShadow: '0 6px 20px rgba(67, 56, 202, 0.25)',
      },
    }
    
    const styles = variantStyles[variant] || variantStyles.first
    
    return `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
    padding: 0;
    border: 1.5px solid ${styles.borderColor};
    border-radius: 10px;
    background: ${styles.background};
    color: ${styles.color};
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 
      0 2px 8px rgba(0, 0, 0, 0.1),
      0 1px 3px rgba(0, 0, 0, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.2);
    position: relative;
    overflow: hidden;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, transparent 100%);
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    
    &:hover {
      background: ${styles.hoverBackground};
      border-color: ${styles.borderColor.replace('0.3', '0.5')};
      box-shadow: ${styles.hoverShadow}, 0 2px 8px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px) scale(1.05);
      
      &::before {
        opacity: 1;
      }
    }
    
    &:active {
      transform: translateY(0) scale(1);
      box-shadow: 
        0 2px 6px rgba(0, 0, 0, 0.15),
        inset 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    
    &:focus {
      outline: none;
      box-shadow: 
        ${styles.hoverShadow},
        0 0 0 3px rgba(67, 56, 202, 0.2);
    }
    
    &:focus-visible {
      outline: 2px solid rgba(67, 56, 202, 0.5);
      outline-offset: 2px;
    }
    
    @media (min-width: 768px) {
      width: 40px;
      height: 40px;
      min-width: 40px;
      min-height: 40px;
      border-radius: 11px;
    }
    
    @media (min-width: 1200px) {
      width: 42px;
      height: 42px;
      min-width: 42px;
      min-height: 42px;
    }
    
    @media (max-width: 600px) {
      width: 32px;
      height: 32px;
      min-width: 32px;
      min-height: 32px;
      border-radius: 8px;
      border-width: 1px;
    }
    
    svg {
      position: relative;
      z-index: 1;
      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
    }
  `
  },
)

// search section parent

export const SearchSectionParent = styled.div`
  width: 600px;
  @media (max-width: 600px) {
    width: 100%;
  }
`

//// patient info styles

export const PIParent = styled.div`
  width: 600px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 600px) {
    width: 100%;
    flex-direction: column;
    gap: 10px;
  }
`

export const PISection = styled.div`
  width: 45%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  @media (max-width: 600px) {
    width: 100%;
  }
`
export const PIFormSection = muiStyled(Grid2)(
  ({ theme }) => `
  display: flex;
  gap: 8px;
`,
)

export const PISectionItem = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
`

export const PISectionValidation = styled.div`
  width: 100%;
  font-size: 12px;
  color: red;
`

export const PISectionTitle = styled.div`
  width: 80px;
  flex-shrink: 0;
  font-weight: 500;
`

export const PISectionInput = styled.input`
  color: rgba(67, 56, 202, 0.9);
  border: 1px solid rgba(67, 56, 202, 0.2);
  border-radius: 5px;
  padding: 5px 10px;
  width: 100%;
  transition: all 0.2s ease;
  &:focus {
    outline: none;
    border-color: rgba(67, 56, 202, 0.4);
    box-shadow: 0 0 0 3px rgba(67, 56, 202, 0.1);
  }
  &:hover {
    border-color: rgba(67, 56, 202, 0.3);
  }
  &:disabled {
    background: rgba(67, 56, 202, 0.05);
    border-color: rgba(67, 56, 202, 0.1);
  }
`

//// rectangular radio button

export const RRBContainer = styled.div`
  width: 100%;
  display: flex;
  border-radius: 5px;
  border: 1px solid #b2b2b2;
  overflow: hidden;
`

export const RRBItem = muiStyled(ButtonBase)(({ selected }) => ({
  padding: '3px 3px',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  background: selected ? '#b7d7f9' : 'inherit',
  borderLeft: selected ? '1px solid #a8cff8' : '1px solid #fff',
  borderRight: selected ? '1px solid #a8cff8' : '1px solid #fff',
  '&:hover': {
    background: selected ? '#a8cff8' : 'inherit',
  },
}))

////// mobile input

export const EDVCPhoneInput = styled(PhoneInput)`
  width: 100%;
  max-width: 315px;
  .form-control {
    border: 1px solid #707070;
    border-radius: 5px;
    color: #242424;
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
`

//// cash denomation stuff:

export const CashDenominationInput = styled.input`
  border: 1px solid #b2b2b2;
  border-radius: 3px;
  padding: 3px;
  width: 40px;
  font-weight: 500;
  &:focus {
    outline: none;
  }
`

export const CashDenominationText = styled.div`
  width: 60px;
  text-align: right;
`

// prescription individual page

export const PrescriptionIndividualPageParent = styled.div`
  padding: 20px;
  @media print {
    padding: 0px;
    .hide-on-print {
      display: none !important;
    }
    /* NOTE: the @page rule (size/margin) and print-color-adjust live in
       PrescriptionPrintGlobalStyle (a top-level createGlobalStyle in ClinicPrescriptionPage).
       An @page nested inside a styled-component selector is emitted scoped to the generated
       class and ignored by the browser, and print-color-adjust is a no-op inside @page. */
  }
`

// therapy requests stuff:

export const BookingRequestItemsParent = styled.div`
  position: relative;
  padding: 20px;
  width: 100%;
  height: 100%;
`

export const BookingRequestContainer = styled.div`
  padding: 10px;
  display: flex;
  margin: 10px 0px;
  background: #fff8f7;
  border-radius: 8px;
  gap: 5px;
  flex-direction: column;
`

export const FloatingHeaderContainerDayCal = styled.div`
  /* Position will be set via inline styles (sticky/fixed) - don't set default position */
  /* position: relative; - Removed to allow inline styles to control positioning */
  z-index: 999;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(249, 250, 251, 0.98) 100%);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  box-shadow: 
    0 4px 16px rgba(67, 56, 202, 0.08),
    0 2px 8px rgba(0, 0, 0, 0.04),
    0 0 0 1px rgba(67, 56, 202, 0.05);
  border-bottom: 1px solid rgba(67, 56, 202, 0.1);
  border-radius: 16px;
  padding: ${props => (props.$slim ? '6px 16px' : props.compact ? '10px 16px' : '16px 20px')};
  margin: 0 auto;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 16px;
  margin-right: 16px;
  max-width: calc(100% - 32px);
  overflow: hidden;
  min-height: ${props => (props.$slim ? '50px' : props.compact ? '70px' : '96px')};
  /* Transition will be controlled by inline styles, but keep a default */
  will-change: transform, opacity;
  
  @media (max-width: 768px) {
    /* Position will be set via inline styles (fixed) - don't set default position */
    /* position: relative; - Removed to allow inline styles to control positioning */
    padding: ${props => props.compact ? '4px 8px' : '6px 10px'};
    border-radius: 12px;
    margin-left: 12px;
    margin-right: 12px;
    max-width: calc(100% - 24px);
    box-shadow:
      0 2px 8px rgba(67, 56, 202, 0.06),
      0 1px 4px rgba(0, 0, 0, 0.03),
      0 0 0 1px rgba(67, 56, 202, 0.04);

    /* $flush (mentor mobile): the date tabs shouldn't sit in a floating card — drop the rounded
       card, side margins, shadow and the forced min-height so they're a flush, height-hugging bar. */
    ${props =>
      props.$flush
        ? `
      padding: ${props.compact ? '2px 8px 4px' : '4px 10px'};
      border-radius: 0;
      margin-left: 0;
      margin-right: 0;
      max-width: 100%;
      min-height: 0;
      box-shadow: none;
      border-bottom: 1px solid rgba(67, 56, 202, 0.08);
    `
        : ''}
  }
  
  @media (min-width: 1200px) {
    margin-left: 24px;
    margin-right: 24px;
    max-width: calc(100% - 48px);
    border-radius: 20px;
  }
  
  /* Subtle animation on scroll */
  @supports (backdrop-filter: blur(24px)) {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(249, 250, 251, 0.95) 100%);
  }
`

// highlighted blocks:
export const HighlightedBlockContainer = styled.div`
  position: absolute;
  width: calc(100%);
  right: 20px;
  top: ${(props) => `${20 + props?.fromTopInPx}px`};
  height: ${(props) => `${props?.heightInPx}px`};
  background: rgba(0, 128, 128, 0.05);
  border-radius: 2px;
  pointer-events: none;
`

export const HighlightedBlockStartMarker = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 8px;
  color: #2d333a;
  width: calc(100% - 70px);
  display: flex;
  justify-content: center;
  text-align: center;
  background: rgba(0, 128, 128, 0.2);
`

export const HighlightedBlockEndMarker = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 8px;
  color: #2d333a;
  width: calc(100% - 70px);
  display: flex;
  justify-content: center;
  text-align: center;
  background: rgba(0, 128, 128, 0.2);
`

export const EachSlotDurationInMinsSelectionBox = styled.div`
  padding: 2px 8px;
  cursor: pointer;
  font-size: 12px;
  ${(props) => props?.bl && 'border-left: 1px solid #cecece;'};
  ${(props) => props?.br && 'border-right: 1px solid #cecece;'};
  background: ${(props) => (props?.selected ? '#005FB8' : '$fff')};
  color: ${(props) => (props?.selected ? '#fff' : '$000')};
`
